import React, { useContext, useEffect } from 'react';
import theme from '../theme/theme';
import { searchLeagues } from '../services/leagueService';
import { useNavigate } from "react-router-dom";
import { Autocomplete, Avatar, Box, Chip, Grid,
         InputAdornment, Popper, TextField, createFilterOptions, styled, Typography, Tooltip } from '@mui/material';
import { globalStore } from '../state/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faLock, faGlobe } from '@fortawesome/free-solid-svg-icons';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: theme.palette.primary.main,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root': {
    //backgroundColor: 'transparent',
    backgroundColor: '#ffffff',
    borderRadius: '40px',
    padding: '20px 25px',
    '& fieldset': {
      borderColor: 'transparent',
      boxShadow: 'rgba(0, 0, 0, 0.10) 0px 3px 34px 0px',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
      boxShadow: 'rgba(0, 0, 0, 0.20) 0px 3px 34px 0px',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
      boxShadow: 'rgba(0, 0, 0, 0.20) 0px 3px 34px 0px',
    },
  },
});

const StyledPopper = styled(Popper)(({ theme }) => ({
  '& .MuiAutocomplete-groupLabel': {
    fontWeight: '700',
    color: theme.palette.grey[900],
    fontSize: '14px',
    textTransform: 'uppercase',
    //boxShadow: 'rgba(0, 0, 0, 0.05) 0px 3px 24px 0px',
            //backgroundColor: grey50,
            //border: '1px solid' + grey200,
  },
  '& .MuiAutocomplete-option': {
    paddingTop: '15px',
    paddingBottom: '15px',
  },
  
}));

export default function SearchBar(props) {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(globalStore);
  const [loading, setLoading] = React.useState(false);
  const [searchOptions, setSearchOptions] = React.useState([]);
  const [searchSelection, setSearchSelection] = React.useState(null);

  const handleSearchInput = async (event, value) => {
    if (!value || value.length < 2) {
      setSearchOptions([]);
      return;
    }
    
    setLoading(true);
    try {
      const results = await searchLeagues(value);
      setSearchOptions(results.map(league => ({
        title: league.name,
        //category: 'Leagues',
        isLabel: false,
        isLocked: league.isLocked,
        avatar: league.logoURL ? 
          <Avatar alt={league.name} src={league.logoURL} sx={{width: '35px', height: '35px'}} /> : 
          null,
        _id: league.id
      })));
    } catch (error) {
      console.error("Search error:", error);
      setSearchOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchSelection = (newValue) => {
    console.log("searchChange", newValue)
    if(Boolean(newValue) && Boolean(newValue._id)) {
      navigate(`/league/join/${newValue._id}`);
    }
    setSearchSelection(newValue);
  }

  return (
    <div>  
      <Autocomplete
        id="tags-outlined"
        freeSolo
        options={searchOptions}
        value={searchSelection}
        loading={loading}
        onChange={(event, newValue) => { handleSearchSelection(newValue) }}
        onInputChange={handleSearchInput}
        getOptionLabel={(option) => option.title}
        groupBy={(option) => option.category}
        PopperComponent={StyledPopper}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip 
              variant="filled" 
              color={option.isLabel ? option.colorType : "default"}
              sx={option.isLabel ? {fontWeight: '600'} : {backgroundColor: theme.palette.grey[200]}}
              avatar={option.isLabel ? null : option.avatar}
              label={option.title} 
              {...getTagProps({ index })} 
            />
          ))
        }
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            {option.avatar}
            <Typography sx={{marginLeft: '15px'}}>
              {option.title}&nbsp;&nbsp;
              <Tooltip title={option.isLocked ? "Private league" : "Public league"} arrow>
                <span>
                  <FontAwesomeIcon 
                    icon={option.isLocked ? faLock : faGlobe} 
                    style={{
                      color: option.isLocked ? theme.palette.primary.main : theme.palette.success.main, 
                      fontSize: '13px'
                    }} 
                  />
                </span>
              </Tooltip>
            </Typography>
          </Box>
        )}
        renderInput={(params) => (
          <CssTextField
            {...params}
            variant="outlined" 
            fullWidth
            placeholder="Find league..."
            InputProps={{
              ...params.InputProps,
              autoComplete: 'new-password',
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faSearch} color={theme.palette.primary.main} />
                </InputAdornment>
              ),
            }}  
          />
        )}
      />
    </div>
  );
}